import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./index.module.css";

// const toster_config = {
//   position: "top-right",
//   autoClose: 3000,
//   hideProgressBar: true,
//   closeOnClick: true,
//   pauseOnHover: false,
//   draggable: true,
//   progress: undefined,
//   theme: "light",
// };

// export const successToast = (msg) => {
//   const isMobile = window.innerWidth <= 700;
//   return toast.success(msg, {
//     ...toster_config,
//     style: {
//       width: "max-content",
//       color: isMobile ? "#252525" : "#000000",
//       backgroundColor: "#DFFFE5",
//       borderLeft: "20px solid #62BA60",
//       borderRadius: "12px",
//       fontWeight: 500,
//       gap:"20px"
//     },
//     icon: ({ theme, type }) => (
//       <img
//         src={Icons.SuccessToast}
//         alt=""
//         style={{
//           width: isMobile ? "10.256vw" : "40px",
//           height: isMobile ? "10.256vw" : "40px",
//         }}
//       />
//     ),
//   });
// };

// export const errorToast = (msg) => {
//   const isMobile = window.innerWidth <= 700;
//   return toast.error(msg, {
//     ...toster_config,
//     style: {
//       color: isMobile ? "#252525" : "#000000",
//       backgroundColor: "#FFCBC2",
//       borderLeft: "20px solid #ED705B",
//       borderRadius: "12px",
//       fontWeight: 500,
//     },
//     icon: ({ theme, type }) => (
//       <img
//         src={Icons.ErrorToast}
//         alt=""
//         style={{
//           width: isMobile ? "7.692vw" : "25px",
//           height: isMobile ? "7.692vw" : "25px",
//           marginRight: isMobile ? "" : "10px",
//           marginTop: isMobile ? "5px" : "",
//         }}
//       />
//     ),
//   });
// };

// export const warnToast = (msg) => {
//   const isMobile = window.innerWidth <= 700;
//   return toast.warn(msg, {
//     ...toster_config,
//     style: {
//       color: isMobile ? "#252525" : "#000000",
//       backgroundColor: "#F2E1B8",
//       borderLeft: "20px solid #D9A62E",
//       borderRadius: "12px",
//       fontWeight: 500,
//       width: "fit-content",
//     },
//     icon: ({ theme, type }) => (
//       <img
//         src={Icons.WarnToast}
//         alt=""
//         style={{
//           width: isMobile ? "7.256vw" : "25px",
//           height: isMobile ? "7.256vw" : "25px",
//         }}
//       />
//     ),
//   });
// };

// export const infoToast = (msg) => {
//   return toast.info(msg, toster_config);
// };

export const Toaster = () => {
  return (
    <ToastContainer
      toastClassName={styles.Toastify__toast}
      position="top-right"
      autoClose={5000}
      limit={1}
      hideProgressBar={false}
      closeOnClick={true}
      pauseOnHover={false}
      draggable={true}
      theme="light"
    />
  );
};
